// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"97a2e5d3","550":"53f6776c"}[chunkId] + ".chunk.css";
};